module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ir-c945dfdfaee26ad2861c09ba9c678844.svg";